import * as React from 'react'
import styled, { keyframes } from 'styled-components'

import GradientSpinner from '../../../assets/img/gradient-spinner.png'

const Rotate = keyframes`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`

const StyledSpinner = styled.img.attrs({ src: GradientSpinner })`
  max-width: ${props => (props.small ? '30px' : '64px')};

  animation-name: ${Rotate};
  animation-duration: 750ms;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-fill-mode: forwards;
`

function Spinner({ small }) {
  // TODO: define template, behaviors etc.
  return <StyledSpinner small={small} />
}

Spinner.defaultProps = {
  // TODO: specify default props
}

Spinner.propTypes = {
  // TODO: specify prop types
}

export default Spinner
